import React, { type ReactElement, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { SidePanel } from '@saviynt/design-system';

import {
  IS_READ_ONLY,
  VIOLATIONS_TAB_LIST_FOOTER_KIND,
} from '../../../../shared/constants';
import {
  useInvertedLocalize,
  useTypedSelector,
} from '../../../../shared/hooks';
import { testIds } from '../../../../tests';
import { violationsTabActions } from '../../data-store/violationsTabSlice';
import ViolationsListActions from '../ViolationsListActions';

import ViolationsSidePanelBody from './ViolationsSidePanelBody';

import './ViolationsSidePanel.css';

/**
 * ViolationsSidePanel
 */
function ViolationsSidePanel(): ReactElement {
  const l = useInvertedLocalize();
  const dispatch = useDispatch();
  const {
    controls: { tabInAction },
    bulkaction: { isFooterVisible },
    sidepanel: { isSidePanelVisible, rowContext },
  } = useTypedSelector((state) => state.aag.violationsTab);
  const sidepanelRef = useRef(null);

  const handleSidePanelClose = () =>
    dispatch(violationsTabActions.setIsSidePanelVisible(false));

  return (
    <SidePanel
      ref={sidepanelRef}
      header={{
        title: rowContext.current.title,
        description: l('Violation by {username}', {
          username: rowContext.current.username ?? '',
        }),
        icon: 'SOD',
      }}
      layout={
        <ViolationsSidePanelBody
          currentRowContext={rowContext.current}
          sidepanelRef={sidepanelRef}
        />
      }
      isOpen={isSidePanelVisible}
      onClose={() => {
        handleSidePanelClose();
      }}
      footer={
        <ViolationsListActions
          kind={VIOLATIONS_TAB_LIST_FOOTER_KIND.FOOTER}
          tabInAction={tabInAction}
          isDisabled={isFooterVisible || IS_READ_ONLY}
          rowContext={rowContext.current}
        />
      }
      isSidePanelNavigatingList
      isPreviousDisabled
      isNextDisabled
      isMobileWidth={false}
      isTabletWidth={false}
      className='Sod-ViolationsSidePanel'
      headerClassName='Sod-ViolationsSidePanel-header'
      layoutClassName='Sod-ViolationsSidePanel-layout'
      innerContentClassName='Sod-ViolationsSidePanel-innerContent'
      footerClassName='Sod-ViolationsSidePanel-footer'
      dataTestId={testIds.SOD_VIOLATIONS_TAB_SIDE_PANEL}
    />
  );
}

export default ViolationsSidePanel;
